module.exports = __webpack_public_path__ + "img/web_wenz02.37ba04d3.png";